import React, { useEffect, useState } from 'react';

export type NumericEntry_inputExProps = {
  value: number;
  minValueLimit?: number;
  maxValueLimit?: number;
  onChange?: (value: number) => void;
  fixed?: number; //小数点桁数指定
  className?: string;
};

/**
 * 上下限値に応じた値を設定
 * @param val
 * @param minLimit
 * @param maxLimit
 * @returns
 */
const CheckValLimit = (val: number, minLimit?: number, maxLimit?: number): number => {
  console.debug([`CheckValLimit val = ${val} minLimit=${minLimit} maxLimit=${maxLimit}`]);
  var ret = val;

  if (minLimit != null && ret < minLimit) {
    ret = minLimit;
  }
  if (maxLimit != null && ret > maxLimit) {
    ret = maxLimit;
  }
  return ret;
};

/**
 * 数値入力 最大値 最小値 設定可能コンポーネント
 * @param props
 * @returns
 */
const NumericEntry_inputEx: React.FC<NumericEntry_inputExProps> = (props: NumericEntry_inputExProps) => {
  //console.debug(['NumericEntry_inputEx() - props', props]);
  //console.debug( props.fixed != undefined ? "NumericEntry_inputEx true." : "NumericEntry_inputEx false");
  const initVal = props.fixed != undefined ? props.value.toFixed(props.fixed) : props.value.toString();
  const [val, setVal] = useState<string>(initVal);

  useEffect(() => {
    //console.debug(['- useEffect - props.value, initVal ??', props.value, initVal ?? '']);
    setVal(initVal ?? '');
  }, [props.value]);

  return (
    <input
      type="text"
      className={'MuiInput-underline' + ' ' + props.className}
      value={val}
      style={{ textAlign: 'right' }}
      onChange={(e) => {
        const iv = parseFloat(e.target.value);
        if (!isNaN(iv)) {
          setVal(e.target.value);
        } else {
          setVal('0');
        }
      }}
      onBlur={(e) => {
        const cv = CheckValLimit(parseFloat(val), props.minValueLimit, props.maxValueLimit);
        const ret = props.fixed != undefined ? cv.toFixed(props.fixed) : cv.toString();
        console.debug(`-onBlur - props.fixed:${props.fixed}, setval:${ret}`);
        setVal(ret);
        if (props.onChange) {
          props.onChange(Number(ret));
        }
      }}
      onFocus={(e) => e.target.select()}
    />
  );
};

export default NumericEntry_inputEx;
